// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"Contact--privacyPolicy--pzceyXS","wrapper":"Contact--wrapper--ShMsHRM","title":"Contact--title--kdAZtxa","content":"Contact--content--UK7HWQx"};